import { useState } from 'react'

import { SnackbarConfigTypes } from '../../commons/utils/Types'
import { User } from '../../models/User'
import { getUserByLegacyCode } from '../API/UsersAPI'
import UserSearchView from './UserSearchView'

function UserSearchContainer(): JSX.Element {
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [legacyCode, setLegacyCode] = useState<string>('')
    const [user, setUser] = useState<User | null>(null)
    const [snackbarConfig, setSnackBarConfig] = useState<SnackbarConfigTypes>({
        message: '',
        isVisible: false,
        status: 'success',
    })

    const handleCloseSnackbar = () => {
        setSnackBarConfig({
            ...snackbarConfig,
            isVisible: false,
        })
    }

    const handleLegacyCodeChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setLegacyCode(event.target.value)
    }

    const handleSearch = async () => {
        if (!legacyCode.trim()) {
            setSnackBarConfig({
                message: 'Por favor, informe o código do usuário',
                isVisible: true,
                status: 'warning',
            })
            return
        }

        setIsLoading(true)
        try {
            const response = await getUserByLegacyCode(legacyCode)
            if (response) {
                setUser(response)
                setSnackBarConfig({
                    message: 'Usuário encontrado com sucesso',
                    isVisible: true,
                    status: 'success',
                })
            } else {
                setUser(null)
                setSnackBarConfig({
                    message: 'Usuário não encontrado',
                    isVisible: true,
                    status: 'error',
                })
            }
        } catch (error) {
            setUser(null)
            setSnackBarConfig({
                message: 'Erro ao buscar usuário',
                isVisible: true,
                status: 'error',
            })
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <UserSearchView
            isLoading={isLoading}
            legacyCode={legacyCode}
            user={user}
            snackbarConfig={snackbarConfig}
            handleCloseSnackbar={handleCloseSnackbar}
            handleLegacyCodeChange={handleLegacyCodeChange}
            handleSearch={handleSearch}
        />
    )
}

export default UserSearchContainer
